import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PreviewPrint } from '@app/src/common/PreviewPrint';
import { CategoryModel } from '@app/src/views/Home/listProducts';
import {
  Price,
  Item,
  Description,
  List,
  Title,
  IconInfo,
  ModalContent,
  Subtitle,
} from './styled';
import { Icon } from '@app/src/common/Icon';
import {
  VignetteOptionModal,
  selectExtracharge,
  fetchVignette,
  setVignetteValue,
  FormActions,
  TypePublicationModel,
  setExtracharge
} from '@app/src/views/StepTwo/channelPublication';
import { Modal } from '@app/src/common/Modal';
import { COLORS } from '@app/src/ui';
import { isClientEnv } from '@app/src/utils/validations';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { Checkbox } from '@app/src/common/Checkbox';

const isClient = isClientEnv();

interface Props {
  isShowPhotoUploader?: boolean;
  getPrice?: Function;
  printDataId: number;
  availablePhotos?: number;
}

export const SectionExtracharges: React.FC<Props> = ({
  isShowPhotoUploader,
  getPrice,
  printDataId
}) => {
  const dispatch = useDispatch();
  const [isOpenModalVignette, setIsOpenModalVignette] = useState(false);
  const [settings, setSettings] = useState({
    bold: false,
    titleCenter: false,
    highlight: false,
    starCount: null,
    header: '',
    vignette: false,
    vignetteValue: ''
  });
  const history = useHistory();
  const printStorage = isClient && JSON.parse(sessionStorage.getItem('print'));
  const categoryId = printStorage.general.category;
  const categoryConfig: CategoryModel = CATEGORIES[CATEGORY[categoryId]];

  const [isShowModal, setIsShowModal] = useState(false);
  const [fromInput, setFromInput] = useState(false);

  const printData = useSelector(state => state.print);
  const extracharges = useSelector(state => state.extracharge.data);
  const extrachargesData = extracharges && extracharges[printDataId];
  const currentExtracharge = extrachargesData && extrachargesData.data;
  const { title, description, category } = useSelector(state => state.print.general);
  const printExtracharges = useSelector(state => state.print.extracharges);
  const vignettes = useSelector(state => state.vignette.data);
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const currentChannel: TypePublicationModel = useSelector(state => state.typePublication.selected);
  const newspaperId = currentChannel && currentChannel.newspaperId;
  const counter = useSelector(state => state.myPackageAvailable.counter);
  const counterExtra = counter && counter[newspaperId] && counter[newspaperId].extra;

  useEffect(() => {
    if (currentExtracharge && currentExtracharge.data && currentExtracharge.data.length === 0) {
      dispatch(setExtracharge(newspaperId, currentChannel.extracharge));
    }
  }, [currentExtracharge]);

  useEffect(() => {
    if (printExtracharges && printExtracharges[printDataId] && printExtracharges[printDataId].vignette) {
      dispatch(setVignetteValue(printDataId, printExtracharges[printDataId].vignette));
    }
    if (currentExtracharge && currentExtracharge.length > 0) {
      let obj = {};
      let priceIgv = 0;
      let price = 0;
      currentExtracharge.map((item) => {
        if (item.checked === true) {
          obj[item.style] = item.styleValue;
          priceIgv = priceIgv + item.priceIgv;
          price = price + item.price;
          if (item.style === 'vignette' && extrachargesData.vignette) {
            obj['vignetteValue'] = extrachargesData.vignette.name;
          }
        } else {
          if (item.style === 'vignette') {
            obj['vignetteValue'] = '';
          }
        }
      });
      getPrice && getPrice({
        price,
        priceIgv
      });
      setSettings({
        ...settings,
        ...obj
      });
    }
  }, [currentExtracharge]);

  useEffect(() => {
    if (settings && settings.vignette && vignettes && vignettes.length === 0) {
      dispatch(fetchVignette(category, printDataId));
    }
  }, [settings.vignette, vignettes]);

  useEffect(() => {
    if (settings && (settings.vignette === null || settings.vignette !== true)) {
      console.log('settings vignettes [call]', settings.vignette);
      dispatch(fetchVignette(category, printDataId));
    }
  }, [settings.vignette]);

  useEffect(() => {
    const currentPrints = getPrintsByChannelUnique(currentChannel && currentChannel.newspaperId) || 0;
    currentExtracharge && currentExtracharge.map(
      (extra) => {
        if (extra.checked) {
          const currentExtraAvailable = counterExtra && counterExtra[extra.extrachargeId];
          if (currentPrints > currentExtraAvailable) {
            alert('extracargos insuficientes');
            dispatch(setExtracharge(printDataId, currentChannel.extracharge));
            return;
          }
          if (currentPrints <= currentExtraAvailable) {
            dispatch(selectExtracharge(printDataId, extra.extrachargeId, true, currentExtraAvailable - currentPrints));
          }
        }
      })

    if (print && !isNotAnyPrint(printsByChannel) && isClient) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    }
  }, [printsByChannel]);

  const getPrintsByChannelUnique = (channelId) => {
    const currentData = Object.keys(printsByChannel);
    const byChannel = { 1: [], 2: [], 3: [] };
    if (currentData && currentData.length > 0) {
      currentData.map(item => {
        printsByChannel && printsByChannel[item] && printsByChannel[item].map(el => {
          if (el) {
            byChannel && byChannel[el && el.newspaperId] && byChannel[el && el.newspaperId].push(el);
          }
        })
      })
      return byChannel[channelId] && byChannel[channelId].length;
    }
  };

  const handleBeforeUnload = (e) => {
    const newPrint = { ...printData };
    newPrint['printsByChannel'] = {};
    newPrint['summaryId'] = '';
    newPrint['token'] = '';
    newPrint['extracharges'] = {};
    newPrint['priceTotal'] = {};
    newPrint['photoVignette'] = {};
    isClient && sessionStorage.setItem('print', JSON.stringify(newPrint));
    e.returnValue = '¿Desea descartar cambios?';
  };

  const isNotAnyPrint = (printsByChannel) => {
    let isNotPrint = true;
    let channelsId = printsByChannel && Object.keys(printsByChannel);
    if (channelsId && channelsId.length > 0) {
      channelsId.forEach((key) => {
        isNotPrint = isNotPrint && (printsByChannel && printsByChannel[key] && printsByChannel[key].length === 0)
      })
    }
    return isNotPrint;
  }

  const formatPrice = (price: number) => price.toFixed(2);

  const handleChangeCheckbox = (_isChecked, index, item) => {
    if (_isChecked) {
      setSettings({
        ...settings,
        [item.style]: item.styleValue
      });
      if (item.input === 'vignette') {
        setIsOpenModalVignette(true);
        setFromInput(true);
      }
    } else {
      setSettings({
        ...settings,
        [item.style]: null
      });
    }
    dispatch(selectExtracharge(printDataId, item.extrachargeId, _isChecked));
  };

  const handleClickCloseModal = useCallback((item) => {
    if (settings && !settings.vignetteValue && !item) {
      // const indexVignette = currentExtracharge && currentExtracharge.findIndex(item => item.input === 'vignette');
      dispatch(selectExtracharge(printDataId, item.extrachargeId, false));
      setSettings({
        ...settings,
        vignetteValue: null
      });
    }
    setIsOpenModalVignette(false);
  }, [dispatch]);

  const handleChangeVignette = useCallback((item) => {
    dispatch(setVignetteValue(printDataId, item));
    setSettings({
      ...settings,
      vignetteValue: item.name
    });
    setIsOpenModalVignette(false);
  }, [settings]);

  const handleClickEditVignette = () => {
    setFromInput(false)
    setIsOpenModalVignette(true);
  };

  const handleCloseModal = () => {
    setIsShowModal(false)
  };

  const handleClickIconInfo = () => {
    setIsShowModal(true);
  };

  const getDisplayExtracharges = (item) => (item.alias !== 'fotovineta' && item.alias !== 'palabra-extra') ? true : false;

  const handleClickBack = () => {
    history.push(categoryConfig.paths.purchasePrint.stepCalendar);
  };

  const handleClickNext = () => {
    history.push(categoryConfig.paths.purchasePrint.stepTypePublication);
  };

  return (
    <React.Fragment>
      <Title>
        <span>Vista referencial</span> <IconInfo onClick={handleClickIconInfo}><Icon data-name="icon-info" width="14" height="14" fill={COLORS.BLACK} /></IconInfo>
      </Title>
      <Modal show={isShowModal} closeModal={handleCloseModal}>
        <ModalContent>
          Algunos destaques no se pueden combinar. Por ejemplo: Estrellas con viñetas o con los Encabezados.
        </ModalContent>
      </Modal>
      <VignetteOptionModal
        modalTitle="Seleccione viñeta"
        show={isOpenModalVignette}
        handleClickCloseModal={handleClickCloseModal}
        colorTheme={categoryConfig.color}
        handleChangeRadioInput={handleChangeVignette}
        initialValue={settings && settings.vignetteValue}
        origin={fromInput}
      />
      <PreviewPrint
        channelId={printDataId}
        title={title}
        words={description}
        colorTheme={categoryConfig.color}
        isShowPhotoUploader={isShowPhotoUploader}
        handleClickEditVignette={handleClickEditVignette}
        isEditable
        // imageDefault={printPhotoVignette && printPhotoVignette[printDataId] && printPhotoVignette[printDataId].data}
        {...settings}
      />
      <Subtitle>¿Quieres agregar adicionales?</Subtitle>
      <List>
        {
          currentExtracharge && currentExtracharge.length > 0 &&
          currentExtracharge.map((item, index) => (
            <Item key={index} isDisplay={getDisplayExtracharges(item)}>
              <Checkbox
                handleChange={(isChecked) => handleChangeCheckbox(isChecked, index, item)}
                name={item && item.input}
                value={item && item.value}
                colorActive={COLORS.BLUE_LINK}
                disabled={item && item.disabled}
                checked={item && item.checked}
              >
                <Description>
                  {item && item.name} {
                    <Price>S/ {formatPrice(item && item.price)}</Price>
                  }
                </Description>
              </Checkbox>
            </Item>
          ))
        }
      </List>
      <FormActions
        textButtonBack={'Regresar'}
        handleButtonBack={handleClickBack}
        handleButtonNext={handleClickNext} />
    </React.Fragment>
  )
};
